module.exports = __webpack_public_path__ + "img/blog8.e80291ee.jpg";